import { CSSProperties, useEffect, useRef, useState } from 'react';

export const useCheckboxTemplate = () => {
  const pointsRef = useRef<HTMLDivElement>(null);
  const [pointsHeight, setPointsHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const handleResize = () => {
      if (pointsRef.current) {
        const lastChildHeight = pointsRef.current.lastElementChild?.getBoundingClientRect().height || 0;
        setPointsHeight(pointsRef.current.getBoundingClientRect().height - lastChildHeight - 16);
      }
    };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [pointsHeight]);

  const styles: CSSProperties & Record<string, string> = {
    '--points-height': `${pointsHeight}px`,
  };

  return { styles, pointsRef };
};
